export const WINDOW_SIZE = {
  mobile: 'mobile web',
};
